import { createSlice } from '@reduxjs/toolkit';
import { IS_BEAR_DOMAIN } from '../../config';

const EUR_RUB = IS_BEAR_DOMAIN ? 'RUB' : 'EUR';

export const headerInfoSlice = createSlice({
  name: 'headerInfo',
  initialState: {
    headerInfo: {
      user: {
        first_name: '',
        last_name: '',
      },
      balance: {
        [EUR_RUB]: { total: 'N/A', credit: 'N/A' },
        USD: { total: 'N/A', credit: 'N/A' },
      },
    },
    errorBalance: '',
  },
  reducers: {
    setHeaderInfo: (state, action) => {
      if (action.payload) {
        state.headerInfo = action.payload;
      }
    },
    setErrorBalance(state, action) {
      state.errorBalance = action.payload;
    },
  },
});

export const { setHeaderInfo, setErrorBalance } = headerInfoSlice.actions;

export const selectUserName = (state) =>
  `${state.headerInfo?.headerInfo?.user?.first_name || ''} ${
    state.headerInfo?.headerInfo?.user?.last_name || ''
  }`;

export const selectBalance = (state) => {
  const { balance } = state.headerInfo.headerInfo;
  return Object.keys(balance).reduce(
    (acc, currency) => ({ ...acc, [currency]: balance[currency] }),
    {},
  );
};

export default headerInfoSlice.reducer;
